var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var HTMLHelper = {
    renderNoValues: function (strings) {
        if (!strings[0])
            return '';
        var tempContainer = document.createElement('template');
        tempContainer.innerHTML = strings[0];
        return tempContainer.content;
    },
    generatePlaceholder: function (values, i) {
        var value;
        if (typeof values[i] === 'string' || typeof values[i] === 'number') {
            value = values[i].toString();
        }
        else if (Array.isArray(values[i])) {
            value = "<temp class=\"array\"></temp>";
        }
        else if (values[i] instanceof HTMLElement || values[i] instanceof DocumentFragment) {
            value = "<temp class=\"html\"></temp>";
        }
        else {
            value = '';
        }
        return value;
    },
    generateHTMLString: function (strings, values) {
        return strings.reduce(function (acc, string, i) {
            var placeholder = i < values.length ? HTMLHelper.generatePlaceholder(values, i) : '';
            var str = acc + string + placeholder;
            return str.trim();
        }, '');
    },
    generateTempEl: function (strings, values) {
        var temp = document.createElement('template');
        temp.innerHTML = HTMLHelper.generateHTMLString(strings, values);
        return temp;
    },
    appendHTMLValues: function (values, el) {
        var htmlValueContainers = __spreadArray([], el.querySelectorAll('temp.html'), true);
        var htmlValues = values.filter(function (x) { return x instanceof HTMLElement || x instanceof DocumentFragment; });
        htmlValues.forEach(function (value, i) {
            htmlValueContainers[i].replaceWith(value);
        });
    },
    appendHTMLElements: function (value, fragment, el) {
        // T H I S W O R K S -- Too specific tidy it up
        var isTableElement = ['TR', 'TD', 'TBODY', 'THEAD'].includes(value.tagName);
        if (isTableElement) {
            //Assumes all table elements are written correctly and data attributes have been applied. <table> must have an id & inner elements must have data-ll-table-container="#tableId" if being rendered with html func.
            var table = el.querySelector(value.getAttribute('data-ll-table-container'));
            if (value.tagName == 'TR') {
                table.querySelector('tbody').appendChild(value);
            }
            ;
        }
        else {
            fragment.appendChild(value);
        }
        ;
    },
    appendArrayValues: function (values, el) {
        var arrayValues = values.filter(Array.isArray);
        var arrayValueContainers = __spreadArray([], el.querySelectorAll('temp.array'), true);
        arrayValues.forEach(function (value, i) {
            var fragment = document.createDocumentFragment();
            var processValue = function (arr) {
                arr.forEach(function (x) {
                    if (Array.isArray(x)) {
                        processValue(x);
                    }
                    else if (x instanceof HTMLElement) {
                        HTMLHelper.appendHTMLElements(x, fragment, el);
                    }
                    else if (typeof x === 'string' || typeof x === 'number') {
                        var string = x;
                        fragment.appendChild(html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", ""], ["", ""])), string));
                    }
                    else {
                        fragment.appendChild(x);
                    }
                    ;
                });
            };
            processValue(value);
            arrayValueContainers[i].replaceWith(fragment);
        });
    },
    filterEmptyNodes: function (tempEl) {
        var childNodes = __spreadArray([], tempEl.content.childNodes, true);
        childNodes = childNodes.filter(function (childNode) {
            if (childNode.nodeType === Node.TEXT_NODE) {
                var trimmedText = childNode.textContent.trim();
                if (trimmedText) {
                    return true;
                }
                else {
                    return false;
                }
                ;
            }
            else {
                return true;
            }
            ;
        });
        return childNodes;
    }
};
export var html = function (strings) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    if (!values.length)
        HTMLHelper.renderNoValues(strings);
    var tempEl = HTMLHelper.generateTempEl(strings, values);
    HTMLHelper.appendHTMLValues(values, tempEl.content);
    HTMLHelper.appendArrayValues(values, tempEl.content);
    var childNodes = HTMLHelper.filterEmptyNodes(tempEl);
    return childNodes.length > 1 ? childNodes : childNodes[0];
};
var templateObject_1;
